import { Chip, Theme, withStyles, WithStyles } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';
import React from 'react';
const styles = (theme: Theme) =>
  createStyles({
    root: {},
    chip: {
      marginRight: '0.5rem',
      marginBottom: 3
    }
  });

class FilterItem extends React.Component<IFilterItemProps> {
  public render() {
    const { classes } = this.props;
    return (
      <Chip
        label={this.props.label}
        onDelete={() => this.props.onClose()}
        className={classes.chip}
      />
    );
  }
}
interface IFilterItemOwnProps extends WithStyles<typeof styles> {
  label: string;
  onClose: () => any;
  key: any;
}

type IFilterItemProps = IFilterItemOwnProps;

export default withStyles(styles)(FilterItem);
